/* Probably Late — product page behaviour
   Variant matching (price + availability + hidden id), gallery thumbs,
   and the quantity stepper. Add-to-cart itself is handled by Dawn's
   <product-form>, which posts to /cart/add.js and opens the drawer. */
(function () {
  window.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-pl-product]');
    if (!root) return;

    /* ---- Gallery ---- */
    var mainImage = root.querySelector('[data-pl-main-image]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pl-thumb]'));
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (mainImage && full) {
          mainImage.src = full;
          mainImage.removeAttribute('srcset');
        }
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });

    /* ---- Quantity stepper ---- */
    var qtyInput = root.querySelector('[data-pl-qty-input]');
    root.querySelectorAll('[data-pl-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(btn.getAttribute('data-pl-qty'), 10);
        var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
        qtyInput.value = next;
      });
    });

    /* ---- Variants ---- */
    var dataEl = document.querySelector('[data-pl-variants]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    var variantIdInput = root.querySelector('[data-pl-variant-id]');
    var priceEl = root.querySelector('[data-pl-price]');
    var submit = root.querySelector('[data-pl-submit]');
    var submitText = root.querySelector('[data-pl-submit-text]');
    var addLabel = submitText ? submitText.textContent.trim() : 'Add to cart';
    var optionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-pl-option-input]'));
    if (!optionInputs.length) return;

    var moneyFormat =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: moneyFormat || 'USD'
        }).format(cents / 100);
      } catch (e) {
        return amount;
      }
    }

    function selectedOptions() {
      var byFieldset = {};
      optionInputs.forEach(function (input) {
        if (!input.checked) return;
        var fieldset = input.closest('[data-pl-option-index]');
        if (!fieldset) return;
        byFieldset[fieldset.getAttribute('data-pl-option-index')] = input.value;
      });
      return byFieldset;
    }

    function update() {
      var chosen = selectedOptions();
      var match = variants.find(function (variant) {
        return Object.keys(chosen).every(function (i) {
          return variant.options[i] === chosen[i];
        });
      });

      if (!match) {
        if (submit) submit.disabled = true;
        if (submitText) submitText.textContent = 'Unavailable';
        return;
      }

      if (variantIdInput) {
        variantIdInput.value = match.id;
        variantIdInput.disabled = !match.available;
      }

      if (priceEl) {
        var html = formatMoney(match.price);
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += ' <s class="pl-product__compare">' + formatMoney(match.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = html;
      }

      if (submit) submit.disabled = !match.available;
      if (submitText) submitText.textContent = match.available ? addLabel : 'Sold out';

      // keep the address bar pointing at the chosen variant
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', update);
    });

    update();
  });
})();

/* Probably Late — product gallery carousel (phone only).
   One image at a time, auto-advancing every 2.5s, with arrows and dots.
   The desktop grid shows every image at once, so this stays idle there. */
(function () {
  var wrap = document.querySelector('[data-pl-gallery]');
  if (!wrap) return;

  var track = wrap.querySelector('[data-pl-gallery-track]');
  var cells = Array.prototype.slice.call(wrap.querySelectorAll('.pl-product__cell'));
  var dotsBox = wrap.querySelector('[data-pl-gallery-dots]');
  var prev = wrap.querySelector('[data-pl-gallery-prev]');
  var next = wrap.querySelector('[data-pl-gallery-next]');
  if (!track || cells.length < 2) return;

  var phone = window.matchMedia('(max-width: 749px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DELAY = 2500;
  var timer = null;
  var index = 0;

  // dots
  var dots = cells.map(function (_, i) {
    var d = document.createElement('button');
    d.type = 'button';
    d.className = 'pl-product__dot';
    d.setAttribute('aria-label', 'Image ' + (i + 1));
    d.addEventListener('click', function () {
      go(i);
      hold();
    });
    dotsBox.appendChild(d);
    return d;
  });

  function paint() {
    dots.forEach(function (d, i) {
      d.classList.toggle('is-on', i === index);
    });
  }

  function go(i) {
    index = (i + cells.length) % cells.length;
    track.scrollTo({ left: cells[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    paint();
  }

  function play() {
    stop();
    if (!phone.matches || reduced.matches) return;
    timer = setInterval(function () {
      go(index + 1);
    }, DELAY);
  }

  function stop() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  // pause briefly after a manual interaction, then resume
  var resume = null;
  function hold() {
    stop();
    clearTimeout(resume);
    resume = setTimeout(play, DELAY * 2);
  }

  if (prev) prev.addEventListener('click', function () { go(index - 1); hold(); });
  if (next) next.addEventListener('click', function () { go(index + 1); hold(); });

  // keep the index honest when the shopper swipes
  var settle = null;
  track.addEventListener('scroll', function () {
    clearTimeout(settle);
    settle = setTimeout(function () {
      var mid = track.scrollLeft + track.clientWidth / 2;
      cells.forEach(function (c, i) {
        if (mid >= c.offsetLeft - track.offsetLeft && mid < c.offsetLeft - track.offsetLeft + c.offsetWidth) index = i;
      });
      paint();
    }, 120);
  }, { passive: true });

  track.addEventListener('pointerdown', hold);
  phone.addEventListener('change', play);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop();
    else play();
  });

  paint();
  play();
})();

/* Probably Late — Buy Now.
   Adds the variant, then goes straight to checkout. Add To Cart is handled
   by pl-cart.js, which opens the drawer instead. */
(function () {
  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-pl-buy]') : null;
    if (!btn) return;
    event.preventDefault();
    if (btn.disabled || btn.dataset.plBusy === '1') return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var label = btn.textContent;
    btn.dataset.plBusy = '1';
    btn.setAttribute('aria-busy', 'true');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res.status) throw new Error(res.description || 'Add to cart failed');
        window.location.href = root + 'checkout';
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.dataset.plBusy = '';
        btn.removeAttribute('aria-busy');
        setTimeout(function () {
          btn.textContent = label;
        }, 1500);
      });
  });
})();
